module.exports = __webpack_public_path__ + "img/jnt.e55f8ae8.svg";